import * as z from "zod";

export const userFormSchema = z.object({
  username: z.string(),
  email: z.string().email(),
  password: z.string().min(8).optional(),
  first_name: z.string(),
  last_name: z.string(),
  status: z.enum(["active", "inactive"]).optional(),
});
